module.exports = __webpack_public_path__ + "img/arrow_up.b0e52c35.svg";